import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi2";
import { Card, CardContent } from "../ui/CustomCard/CustomCard";

export function FlowEntryCard({
  Icon,
  title,
  description,
  path,
  onGetStarted,
  isBlocked = false,
  ctaLabel = "Get Started",
}) {
  return (
    <Card
      className={`h-full bg-white border-0 shadow transition-all duration-200 ${isBlocked ? "opacity-50 cursor-not-allowed" : "hover:shadow-lg hover:-translate-y-1 group"}`}
    >
      <CardContent className="h-full pt-8 pb-6 px-6 sm:pt-10 sm:pb-8 sm:px-8 flex flex-col items-center text-center gap-4 sm:gap-5">
        <div className="w-10 h-10 rounded-full flex items-center justify-center bg-blue-100 text-primary-600 flex-shrink-0">
          <Icon className="h-5 w-5" />
        </div>

        <div className="flex-1">
          <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-1.5">
            {title}
          </h3>
          <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
            {description}
          </p>
        </div>

        {isBlocked ? (
          <span className="flex items-center gap-1.5 text-xs sm:text-sm font-medium text-gray-400 cursor-not-allowed">
            {ctaLabel}
            <HiArrowRight className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
          </span>
        ) : (
          <Link
            to={path}
            onClick={onGetStarted}
            className="flex items-center gap-1.5 text-xs sm:text-sm font-medium text-primary-600 hover:text-primary-700 underline underline-offset-2 group-hover:gap-2.5 transition-all duration-150"
          >
            {ctaLabel}
            <HiArrowRight className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
          </Link>
        )}
      </CardContent>
    </Card>
  );
}
